import React from 'react';
import Highcharts from "highcharts";
import HighchartsTreemap from "highcharts/modules/treemap";
import HighchartsReact from "highcharts-react-official";
import { useSelector } from "react-redux";
import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from "@material-ui/core";
import { toolbarHeight } from "components/app/Styles";
import useStyles, {
  aboutTogglebarWidth,
  filterContainerHeight,
  chartTitleHeight,
  chartTogglebarWidth,
  aboutDrawerWidth
} from "../common/Styles";
import useGetViewPortDimensions from 'hooks/useGetViewPortDimensions';

HighchartsTreemap(Highcharts);

const getWindowSize = () => {
  const { innerWidth, innerHeight } = window;
  return { innerWidth, innerHeight };
};

const CitiesTreemap = () => {
    const { toggle_about, all_cities_water_use } = useSelector((state) => state.water_user);
    const { isMobile } = useGetViewPortDimensions();
    const colors = [
        "#0C1B5F",
        "#2352D0",
        "#6AA4DC",
        "#96D9E4",
        "#F3C745",
        "#D88C31",
        "#DE3E40",
        "#AF1D1F",
        "#203864",
        "#2F5597",
        "#800080",
        "#6398D9",
        "#A8C7ED",
        "#9191E2",
        "#5252E2",
        "#0C1B5F",
        "#2352D0",
        "#6AA4DC",
        "#96D9E4",
        "#F3C745",
        "#D88C31",
        "#DE3E40",
        "#AF1D1F",
        "#203864",
        "#2F5597",
        "#800080",
        "#6398D9",
        "#A8C7ED",
        "#9191E2",
        "#5252E2",
        "#0C1B5F",
        "#2352D0",
        "#6AA4DC",
        "#96D9E4",
        "#F3C745",
        "#D88C31",
        "#DE3E40",
        "#AF1D1F",
        "#203864",
        "#2F5597",
        "#800080",
        "#6398D9",
        "#A8C7ED",
        "#9191E2",
        "#5252E2",
    ];

    const classes = useStyles();
    const [windowSize, setWindowSize] = React.useState(getWindowSize());
    const [type, setType] = React.useState('tap_water');
    const [options, setOptions] = React.useState(null);
    const [, setData] = React.useState([]);

    React.useEffect(() => {
        const handleWindowResize = () => {
            setWindowSize(getWindowSize());
        };
        window.addEventListener("resize", handleWindowResize);        
        return () => {
          window.removeEventListener("resize", handleWindowResize);
        };
    }, []);

    const toggleHook = () => {
      let series = [];
      Object.keys(all_cities_water_use).map((city, idx) => {
        series.push({
          name: city,
          value: all_cities_water_use[city][type]
        });
        return city
      });
      series.sort(function compare(a, b) {
        if (a.value > b.value) {
          return -1;
        } else if (a.value < b.value) {
          return 1;
        }
        return 0;
      });
      setData(series);      
      let options_temp = {
        chart: {
          backgroundColor: "transparent",
          width: isMobile ? 380 :
            windowSize.innerWidth -
            chartTogglebarWidth -
            (toggle_about ? aboutDrawerWidth : aboutTogglebarWidth) -
            80, // 80 for padding
          maxWidth: isMobile ? 390 :
            windowSize.innerWidth -
            chartTogglebarWidth -
            aboutTogglebarWidth -
            100,
          height:
            windowSize.innerHeight -
            toolbarHeight -
            filterContainerHeight -
            chartTitleHeight -
            150,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            type: "treemap",
            layoutAlgorithm: "squarified",
            dataLabels: {
              align: "left",
              verticalAlign: "top",
              paddingTop: 12,
              paddingLeft: 12,
              color: "#FFF",
              style: {
                fontSize: 14,
                lineHeight: 18,
                fontFamily: "'Arial', sans-serif",
                fontWeight: "normal",
                textOutline: 0,
              },
            },
            data: [],
          },
        ],
        title: { style: { display: "none" } },
        tooltip: {
          padding: 16,
          backgroundColor: "#FFF",
          borderRadius: 8,
          style: { color: "#000", fontFamily: "'Arial', sans-serif" },
          formatter() {
            const index = this.point.index;
            return series[index].name + ": " + series[index].value.toLocaleString('en-US')+" ac-ft";
          }
        },
      };      
      options_temp.series[0].data = [];
      series.map((city, idx) => {
        options_temp.series[0].data.push({
          name: city.name,
          value: city.value,
          color: colors[idx],
          states: {
            hover: { fill: colors[idx] },
          },
        });
        return city
      });
      setOptions(options_temp);
    }
    React.useEffect(toggleHook, [type, toggle_about]);

    return (
        <Box className={classes.chartContainer} flexDirection='column' alignItems={'center'} style={{ paddingLeft: 15, paddingRight: 15 }}>
          <FormControl>
            <RadioGroup
              value={type}
              name="radio-buttons-group"
              style={{ display: 'flex', flexDirection: 'row' }}
              onChange={(e) => setType(e.target.value)}
            >
              <FormControlLabel value="tap_water" control={<Radio classes={{root: classes.radio, checked: classes.checked}}/>} label={<Typography variant="body2" className={classes.radioLabel}>Tap Water</Typography>} />
              <FormControlLabel value="turf" control={<Radio classes={{root: classes.radio, checked: classes.checked}}/>} label={<Typography variant="body2" className={classes.radioLabel}>Turf</Typography>} />
              <FormControlLabel value="aquifer_recharge" control={<Radio classes={{root: classes.radio, checked: classes.checked}}/>} label={<Typography variant="body2" className={classes.radioLabel}>Aquifer Recharge</Typography>} />
              <FormControlLabel value="agriculture" control={<Radio classes={{root: classes.radio, checked: classes.checked}}/>} label={<Typography variant="body2" className={classes.radioLabel}>Agriculture</Typography>} />
            </RadioGroup>
          </FormControl>         
          <HighchartsReact highcharts={Highcharts} options={options} />
        </Box>
      );

};

export default CitiesTreemap;